<h2 mat-dialog-title>Edit page heading</h2>

<form [formGroup]="form">
  <div class="field">
    <mat-form-field
      class="full-width"
      appearance="outline"
      floatLabel="always">
      <mat-label>Title</mat-label>
      <input
        matInput
        placeholder="Page Title"
        formControlName="title"
      />
    </mat-form-field>
  </div>

  <strong>Page Title Configuration</strong>
  <p>The selections below apply to all page titles in the report</p>
  <div class="dialog-section">
    <div class="switches-section">
      <div class="configuration-switches">
        <mat-checkbox class="configuration-switch" formControlName="date">Show test date</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="sport">Show sport</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="athlete">Show athlete name</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="coach">Show coach name</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="testDisplayId">Show test ID</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="testType">Show test type</mat-checkbox>
      </div>
    </div>
    <div class="color-section">
      <div class="color-field">
        <mat-form-field appearance="outline" class="color-field">
          <mat-label>Title color</mat-label>
          <input 
            matInput 
            type="color"
            [value]="getPageTitleColor()"
            (input)="onThemeColorChange($any($event.target).value)"
            class="color-input">
        </mat-form-field>
      </div>
    </div>
  </div>
</form>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button 
    mat-raised-button 
    color="primary"
    (click)="onUpdate()">
    Update
  </button>
</mat-dialog-actions>